// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionDropdown_root__1cKgt","dropdown":"ActionDropdown_dropdown__2dRxn"};